import React, { ReactNode, useEffect } from 'react';
import { Box, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import SecaoClienteSidebar from './SecaoClienteSidebar';
import SecaoClienteHeader from './SecaoClienteHeader';

interface SecaoClienteLayoutProps {
  children: ReactNode;
}

const SecaoClienteLayout = ({ children }: SecaoClienteLayoutProps) => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  // Verificar autenticação do cliente
  useEffect(() => {
    const token = localStorage.getItem('cliente_access_token');
    if (!token) {
      navigate('/secao-cliente/login');
    }
  }, [navigate]);

  // Fechar sidebar no mobile quando mudar de rota
  useEffect(() => {
    if (isMobile) {
      onClose();
    }
  }, [isMobile]);

  return (
    <Box minH="100vh" bg="gray.50">
      <SecaoClienteSidebar isOpen={isOpen} onClose={onClose} isMobile={isMobile} />
      <SecaoClienteHeader onOpenSidebar={onOpen} isMobile={isMobile} />

      {/* Main Content */}
      <Box ml={{ base: 0, lg: '280px' }} pt="70px" minH="100vh" transition="margin-left 0.3s ease">
        <Box p={{ base: 4, md: 6, lg: 8 }} maxW="1400px" mx="auto">
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default SecaoClienteLayout;
